module.exports = __webpack_public_path__ + "static/fonts/Poppins-ExtraBoldItalic.8afe4dc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-ExtraBoldItalic.ttf
// module id = 1022
// module chunks = 11